/**
 * PUBLIC CONFIGURATION - HARRI 3
 * ---
 *
 * APIServerBaseURL:
 *  - API Base Backend URL
 *
 * MediaServerBaseURL:
 *  - Media Server Base URL
 *
 * name:
 *  - The name of the state ( see UI-Router states ).
 *
 * type:
 *
 * data:
 * controller:
 * templateUrl:
 *
 * loginRequired:
 *  - login is required or not
 *
 * returnToOnLogin:
 *  - return to the page or not if the user press login from that page
 *
 * views:
 *
 *
 * onEnter:
 *  - UI Router onEnter callback
 *
 * onExit:
 *  - UI Router onEnter callback
 *
 * images_size:
 * metaGeneratorTemplate:
 * dynamic-template:
 */

var environmentsConfig = (typeof(window) == 'undefined') ? require("./environments.config.js") : EnvironmentsConfig;

var publicConfiguration = {};

console.debug = function() {};

if (typeof(window) != 'undefined' && environmentsConfig.get('DebugEnabled')) {

    console.log('%c Harri Debugging Mode %c These logs only appear when enabled from environments.config', 'background: #0b8ddd; color: #fff', '');
    console.debug = function (key, msg) {
        console.log('%c DEBUG %c %c ' + key + ' %c ' + msg + ' ', 'background: #0b8ddd; color: #fff', '', 'background: #0b8ddd; color: #fff', 'color: #555');
    }
}

publicConfiguration = {

    "mobileAppData": {
        "candidate": {
            "android_app_id": "com.harri.candidate",
            "ios_app_id": "952339271",
            "ios_enabled": true,
            "android_enabled": true
        },
        "employer": {
            "android_app_id": "com.harri.employer",
            "ios_app_id": "1094228884"
        },
        "teamlive": {
            "android_app_id": "com.harri.team",
            "ios_app_id": "1151499033"
        },
        "harri_live": {
            "android_app_id": "com.harri.manage",
            "ios_app_id": "1458169183"
        },
    },

    "cameraTagVideoLength": 60,

    // cover image min width & height
    "coverPhotoMinWidth": 300,
    "coverPhotoMinHeight": 300,

    "getBaseAPI": function (base) {
        base = base || 'APIServers';
        return environmentsConfig.get(base);
    },
    "getCoreReaderAPI": function () {
        return environmentsConfig.get('coreReaderAPIServers');
    },
    "getLPMServer": function () {
        return environmentsConfig.get('LPMServer');
    },
    "getDailyActivityServer": function () {
        return environmentsConfig.get('DailyActivityServer');
    },
    "getLPMAggregatorServer": function () {
        return environmentsConfig.get('LPMAggregatorServer');
    },
    "getMediaServer": function () {
        return environmentsConfig.get('MediaServer');
    },
    "getTranscodedMediaServer": function () {
        return environmentsConfig.get('TranscodedMediaServer');
    },
    "getTeamCommunicationMediaServer": function () {
        return environmentsConfig.get('TeamCommunicationMediaServer');
    },
    "getTeamMediaServer": function () {
        return environmentsConfig.get('TeamMediaServer');
    },
    "getOMISServer": function () {
        return environmentsConfig.get('OMISServer');
    },
    "isAnalyticsEnabled": function () {
        return environmentsConfig.get('AnalyticsEnabled');
    },
    getGoogleTagsManagerKey: function () {
        return environmentsConfig.get('GoogleTagsManagerKey');
    },
    getAptrinsicKey: function () {
        return environmentsConfig.get('AptrinsicKey');
    },
    getFacebookPixelId: function () {
        return environmentsConfig.get('FacebookPixelId');
    },
    "getCameraTagAppKey": function () {
        return environmentsConfig.get('CameraTagApp');
    },
    "getCameraTagQuestionBankAppKey": function () {
        return environmentsConfig.get('CameraTagQuestionBankApp');
    },
    "getTranslationLookup": function () {
        return environmentsConfig.get('TranslationLookup');
    },
    "getCookieStoreDomain": function () {
        return environmentsConfig.getEnv().host === environmentsConfig.TEAM_SCHEDULE ? environmentsConfig.get('TLCookieStoreDomain') : environmentsConfig.get('cookieStoreDomain');
    },
    "getIpcSubwayDashboardConfig": function () {
        return environmentsConfig.get('IpcSubwayDashboardConfig');
    },
    "getCorporateHost": function () {
        return environmentsConfig.get('corporateHost');
    },
    "getStripePublishableKey": function () {
        return environmentsConfig.get('StripeKey');
    },
    "isMobielPromotionEnabled": function () {
        return environmentsConfig.get('MobilePromotion');
    },
    "isBotsEnabled": function () {
        return environmentsConfig.get('BotsEnabled');
    },
    "isLanguageDetectionEnabled": function () {
        return environmentsConfig.get('GoogleLanguageDetectionEnabled');
    },
    "isOAuthEnabled": function () {
        return environmentsConfig.get('oAuthEnabled');
    },
    "debug": false,
    "refreshRate": 1000 * 60, // 1 min
    "publicData": {
        "menus": {
            "topMenu": [
                {
                    'title': 'Login',
                    'link': '/login'
                },
                {
                    'title': 'Jobs',
                    'link': '/jobs'
                }
            ],
            "signUpMenu": [

                {
                    'title': 'About',
                    'link': '/about-us'
                },
                {
                    'title': 'blog',
                    'link': 'http://blog.harri.com'
                },
                {
                    'title': 'Employers',
                    'link': '/employers'
                },
                {
                    'title': 'Term of use',
                    'link': '/terms'
                },
                {
                    'title': 'Privacy Policy',
                    'link': '/privacy'
                },
                {
                    'title': 'Press',
                    'link': '/press'
                },
                {
                    'title': 'Contact',
                    'link': '/contact'
                },
                {
                    'title': 'F.A.Q',
                    'link': '/faq'
                }
            ],
            "bottomMenu": {
                "Locations": [
                    {
                        'title': 'Brooklyn',
                        'link': '/jobs/location/brooklyn'
                    },
                    {
                        'title': 'Manhattan',
                        'link': '/jobs/location/manhattan'
                    },
                    {
                        'title': 'Queens',
                        'link': '/jobs/location/queens'
                    }
                ],
                "Jobs": [
                    {
                        'title': 'Bartender',
                        'link': '/jobs/position/bartender'
                    },
                    {
                        'title': 'Cashier',
                        'link': '/jobs/position/cashier'
                    },
                    {
                        'title': 'Host/Hostess',
                        'link': '/jobs/position/host+hostess'
                    },
                    {
                        'title': 'kitchen Manager',
                        'link': '/jobs/position/kitchen+manager'
                    },
                    {
                        'title': 'Line cook',
                        'link': '/jobs/position/line+cook'
                    },
                    {
                        'title': 'Assistance Manager',
                        'link': '/jobs/position/assistance+manager'
                    },
                    {
                        'title': 'Delivery Person',
                        'link': '/jobs/position/delivery+person'
                    },
                    {
                        'title': 'Server',
                        'link': '/jobs/position/server'
                    }
                ],
                /*"Talent": [
                 {
                 'title': 'Bartender',
                 'link': '/members/position/bartender'
                 }, {
                 'title': 'Cashier',
                 'link': '/members/position/cashier'
                 }, {
                 'title': 'Host/Hostess',
                 'link': '/members/position/host+hostess'
                 }, {
                 'title': 'kitchen Manager',
                 'link': '/members/position/kitchen+manager'
                 }, {
                 'title': 'Line cook',
                 'link': '/members/position/line+cook'
                 }, {
                 'title': 'Assistance Manager',
                 'link': '/members/position/assistance+manager'
                 }, {
                 'title': 'Delivery Person',
                 'link': '/members/position/delivery+person'
                 },{
                 'title': 'Server',
                 'link': '/members/position/server'
                 }
                 ], */
                "Our Company": [
                    {
                        'title': 'About',
                        'link': '/about-us'
                    },
                    {
                        'title': 'blog',
                        'link': 'http://blog.harri.com'
                    },
                    {
                        'title': 'Press',
                        'link': '/press'
                    },
                    {
                        'title': 'Contact',
                        'link': '/contact'
                    },
                    {
                        'title': 'F.A.Q',
                        'link': '/faq'
                    }
                ]
            }
        }
    },
    "functions": {
        "bindURLWithParams": function (url, params) {

            var binedUrl = url;
            if (params) {
                for (var k in params) {
                    var key = ":" + k;

                    if (key != undefined && key != null) {
                        binedUrl = binedUrl.replace(new RegExp(key, 'g'), params[k])
                    }
                }
            }

            if (typeof(window) != 'undefined' && window.stateParams) {
                // Workaround to keep our code working after update ui-router
                // Before, the dispatcher module was setting the params into $stateParams
                // Now, it is no longer allowed to write to $stateParams
                for (var k in window.stateParams) {
                    var key = ":" + k;
                    binedUrl = binedUrl.replace(new RegExp(key, 'g'), window.stateParams[k])
                }
            }

            return binedUrl;

        },

        "publicDataMappingCallback": function (data, routeOptions, publicFunctions) {
            var mergedData = {};
            for (var urlId in data) {
                for (var dataKey in data[urlId]) {
                    mergedData[dataKey] = data[urlId][dataKey];
                }
            }

            return mergedData;
        },
        "locationFormatter": function (locationsToFormat) {
            var locationsArray = [];

            for (var loc in locationsToFormat) {

                if (!locationsToFormat[loc].formatted_address && locationsToFormat[loc].City && locationsToFormat[loc].State) {
                    locationsToFormat[loc].formatted_address = locationsToFormat[loc].City.name + ", " + locationsToFormat[loc].State.name;
                }

                //if the location is empty
                if ((!locationsToFormat[loc].City || !locationsToFormat[loc].City.id) && (!locationsToFormat[loc].State || !locationsToFormat[loc].State.id)) {
                    continue;
                }

                if (locationsToFormat[loc].City && locationsToFormat[loc].City.id) {

                    if (locationsArray[locationsToFormat[loc].City.id] == undefined) {
                        locationsArray[locationsToFormat[loc].City.id] = {
                            'City': locationsToFormat[loc].City,
                            'Locations': []
                        };
                    }
                    locationsArray[locationsToFormat[loc].City.id].Locations.push(locationsToFormat[loc]);

                } else if (locationsToFormat[loc].State && locationsToFormat[loc].State.id) {


                    if (locationsArray[locationsToFormat[loc].State.id] == undefined) {
                        locationsArray[locationsToFormat[loc].State.id] = {
                            'City': locationsToFormat[loc].State,
                            'Locations': []
                        };
                    }
                    locationsArray[locationsToFormat[loc].State.id].Locations.push(locationsToFormat[loc]);

                }


            }
        },

        "urlize": function (text) {
            if (!text) {
                return '';
            }
            var username = text.toLowerCase().trim();
            return username.replace(/[^a-zA-Z_0-9_\-.]+/g, " ").replace(/\ /g, "-");
        },
        // check video type by url
        "videoType": function (url, isHosted) {

            isHosted = isHosted || false;
            if (/youtube\.com/.test(url)) {
                return 'youtube';
            }

            if (/youtu\.be/.test(url)) {
                return 'youtube';
            }

            if (/vimeo\.com/.test(url)) {
                return 'vimeo';
            }

            if (isHosted == false) {
                return 'hosted';
            }

            return 'unknown';
        },
        "formatProfilesMedia": function (mediaArray) {

            if (mediaArray) {
                for (var i = 0; i < mediaArray.length; i++) {
                    mediaArray[i].media_type = publicConfiguration.functions.videoType(mediaArray[i].path, mediaArray[i].is_hosted);
                    if (mediaArray[i].media_type == 'hosted') {
                        // console.log('pfdsk poskd posdk podks', mediaArray[i])
                    }

                }
            }
        },
        "formatPortfolioMedia": function (mediaArray) {
            var formattedMedia = [];
            var returnedMedia = [];
            var index;

            for (var key in mediaArray) {
                var mediaHolder = mediaArray[key];
                for (var mKey in mediaHolder) {
                    var createdDate = new Date(mediaHolder[mKey].created);

                    index = createdDate.getFullYear() + '_' + createdDate.getMonth();

                    if (formattedMedia[index] == undefined) {
                        formattedMedia[index] = {
                            'gallery': []
                        };

                        // moment is undefined in the Node.js side
                        if (typeof(moment) != 'undefined') {
                            formattedMedia[index].dateTitle = moment(mediaHolder[mKey].created).format('MMMM YYYY');
                        }
                    }
                    mediaHolder[mKey].type = key;
                    if (key == 'video_gallery') {
                        mediaHolder[mKey].media_type = publicConfiguration.functions.videoType(mediaHolder[mKey].path, mediaHolder[mKey].is_hosted);
                    }
                    formattedMedia[index].gallery.push(mediaHolder[mKey]);
                }
            }

            for (var key in formattedMedia) {
                returnedMedia.push(formattedMedia[key]);
            }
            return returnedMedia;

        }
    },
    "head": {
        "defaultHeadTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "HARRI"
            },
            {
                "tag": "meta",
                "attributes": {
                    "name": "description",
                    "content": "Harri provides the most comprehensive suite of tools to help companies attract, discover and connect with the best talent for their needs. Their platform features extensive scheduling and real-time collaboration tools that simplify the labor management process and boosts its overall effectiveness while empowering hospitality companies to discover, interview, hire and onboard new employees on a single, intuitive platform"
                }
            },
            {
                "tag": "meta",
                "attributes": {"name": "keywords", "content": "job,jobs"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:url", "content": "{{request.url}}"}
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:title", "content": "HARRI"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:image",
                    "content": "https://d2cif42w8ibknl.cloudfront.net/logo_400_400.png"
                }
            },
            {
                "tag": "meta",
                "attributes": {"property": "og:site_name", "content": "Harri"}
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:description",
                    "content": "Harri provides the most comprehensive suite of tools to help companies attract, discover and connect with the best talent for their needs. Their platform features extensive scheduling and real-time collaboration tools that simplify the labor management process and boosts its overall effectiveness while empowering hospitality companies to discover, interview, hire and onboard new employees on a single, intuitive platform"
                }
            }
        ],
        "metaGeneratorTemplate": '{% for tag in tags %}' +
        '<{{tag.tag}} {% for key, value in tag.attributes %} {{key}}="{{value | safe}}"  {% endfor %}' +
        '{% if tag.value %} >{% else %} />{% endif %}' +
        '{% if tag.value %}' +
        '{{tag.value}}</{{tag.tag}}>' +
        '{% endif %}' +
        '{% endfor %}'
    },
    "i18n": {
        "supportedLanguages": ["en", "es", "fr", "de", "ru", "pl", "tr", "ar"],
        "languageParser": function (lang, i18nPublicConfiguration) {
            if (i18nPublicConfiguration.supportedLanguages.indexOf(lang) < 0) {
                lang = lang.toLocaleLowerCase();
                lang = lang.replace(/_/g, "-");
                lang = lang.replace(/"/g, "");
                lang = lang.replace(/'/g, "");

                var languages = lang.split(",");

                for (var i in languages) {
                    var parsedLang = languages[i].split(";");
                    parsedLang = parsedLang[0].split("-");
                    if (i18nPublicConfiguration.supportedLanguages.indexOf(parsedLang[0]) >= 0) {
                        return parsedLang[0];
                    }
                }

                return "en";
            }
            return lang;
        },
        "getLanguageUrl": function (lang) {
            return (lang === 'es' ? 'i18n/' : 'static_langs/') + lang + '.js'
        }
    },
    "keys": {
        "linkedin": {"APIKey": "77bp6c91pof91q", 'permissions': ['r_emailaddress', 'r_liteprofile']},
        "facebook": {
            'permissions': ['email'],
            "AppId": typeof(window) != 'undefined'? environmentsConfig.get("FacebookAppId"): ''
        },
        "google": {
            "services": typeof (window) != 'undefined' ? environmentsConfig.get('GoogleServiceKey') : '',
            "oauthClientId": typeof(window) != 'undefined' ? environmentsConfig.get("GoogleClientID") : '',
            "captcha": typeof(window) != 'undefined'? environmentsConfig.get("GoogleRecaptchaSiteKey"): ''
        },
        "outlook": {
            "oauthClientId": typeof(window) != 'undefined' ? environmentsConfig.get("OutlookClientID") : '',
        },
        "checkr": {
            "oauthClientId": typeof(window) != 'undefined' ? environmentsConfig.get("checkrClientId") : '',
            "checkrDomain": typeof(window) != 'undefined' ? environmentsConfig.get("checkrDomain") : '',
        },
        "indeed": {
            "clientId": typeof(window) !== 'undefined' ? environmentsConfig.get("indeedClientId") : '',
        }
    },
    "support": {
        "email": "feedback@harri.com"
    },
    "analytics": {
        //Production Configuration - Please don't change it.
        "enable-form-analytics": false
    },
    "MandBClickIQClientKey": "4e16703f-6637-4ae5-b42f-61e5473358fc",

};

// Init server configurations, not exposed to Node.js in this way
if (typeof (window) != 'undefined') {
    publicConfiguration["APIServerBaseURL"] = publicConfiguration.getBaseAPI();
    publicConfiguration["tsCoreServersBaseURL"] = publicConfiguration.getBaseAPI('tsCoreServers');
    publicConfiguration["coreReaderAPIServersBaseURL"] = publicConfiguration.getBaseAPI('coreReaderAPIServers');
    publicConfiguration["OnboardingServerBaseURL"] = publicConfiguration.getBaseAPI('OnboardingServers');
    publicConfiguration["DocumentToHtmlConverterLambdaBaseURL"] = publicConfiguration.getBaseAPI('DocumentToHtmlConverterLambda');
    publicConfiguration["PayrollServerBaseURL"] = publicConfiguration.getBaseAPI('Payroll');
    publicConfiguration["SubscriptionServerBaseURL"] = publicConfiguration.getBaseAPI('Subscription');
    publicConfiguration["JobDistributorServerBaseURL"] = publicConfiguration.getBaseAPI('JobDistributor');
    publicConfiguration["TeamServerBaseURL"] = publicConfiguration.getBaseAPI('TeamServers');
    publicConfiguration["AttendanceBaseUrl"] = publicConfiguration.getBaseAPI('Attendance');
    publicConfiguration["TeamScheduleServerBaseURL"] = publicConfiguration.getBaseAPI('TeamScheduleServers');
    publicConfiguration["TeamCommunicationServerBaseURL"] = publicConfiguration.getBaseAPI('TeamCommunicationServers');
    publicConfiguration['SmartSchedulingNotesBaseURL'] = publicConfiguration.getBaseAPI('SmartSchedulingNotes');
    publicConfiguration["TSTeamServerBaseURL"] = publicConfiguration.getBaseAPI('TSTeamServers');
    publicConfiguration["TSAttendanceBaseUrl"] = publicConfiguration.getBaseAPI('TSAttendance');
    publicConfiguration["TSTeamScheduleServerBaseURL"] = publicConfiguration.getBaseAPI('TSTeamScheduleServers');
    publicConfiguration["TSTeamCommunicationServerBaseURL"] = publicConfiguration.getBaseAPI('TSTeamCommunicationServers');
    publicConfiguration["MediaServerBaseURL"] = publicConfiguration.getMediaServer();
    publicConfiguration["OMISServerBaseURL"] = publicConfiguration.getOMISServer();
    publicConfiguration["ReportingServersV1"] = publicConfiguration.getBaseAPI('ReportingServersV1');
    publicConfiguration["HReportingV1"] = publicConfiguration.getBaseAPI('HReportingV1');
    publicConfiguration["ReportingSettingsManagement"] = publicConfiguration.getBaseAPI('ReportingSettingsManagement');
    publicConfiguration["ReportTagManagementV1"] = publicConfiguration.getBaseAPI('ReportTagManagementV1');
    publicConfiguration["ReportingManagementV1"] = publicConfiguration.getBaseAPI('ReportingManagementV1');
    publicConfiguration["GoodMorningToolEngine"] = publicConfiguration.getBaseAPI('GoodMorningToolEngine');
    publicConfiguration["ReportingServers"] = publicConfiguration.getBaseAPI('ReportingServers');
    publicConfiguration["ReportsServers"] = publicConfiguration.getBaseAPI('ReportsServers');
    publicConfiguration["ReportingTrackingServers"] = publicConfiguration.getBaseAPI('ReportingTrackingServers');
    publicConfiguration["InteractionsServerBaseURL"] = publicConfiguration.getBaseAPI('InteractionsServers');
    publicConfiguration["LPMAggregatorServer"] = publicConfiguration.getBaseAPI('LPMAggregatorServer');
    publicConfiguration["TSLPMAggregatorServer"] = publicConfiguration.getBaseAPI('TSLPMAggregatorServer');
    publicConfiguration["InAppNotificationCenter"] = publicConfiguration.getBaseAPI('InAppNotificationCenter');
    publicConfiguration["EVerifyServer"] = publicConfiguration.getBaseAPI('EVerifyServer');
    publicConfiguration["ThoughtSpotAccessManagerServer"] = publicConfiguration.getBaseAPI('ThoughtSpotAccessManagerServer');
    publicConfiguration["ThoughtSpotHost"] = publicConfiguration.getBaseAPI('ThoughtSpotHost');
    publicConfiguration["ATRServers"] = publicConfiguration.getBaseAPI('ATRServers');
    publicConfiguration["WOTCServer"] = publicConfiguration.getBaseAPI('WOTCServer');
    publicConfiguration["StatisticsServers"] = publicConfiguration.getBaseAPI('StatisticsServers');
    publicConfiguration["ChatBot"] = publicConfiguration.getBaseAPI('ChatBot');
    publicConfiguration["CandidateSummary"] = publicConfiguration.getBaseAPI('CandidateSummary');
    publicConfiguration["ApprovalFlowServer"] = publicConfiguration.getBaseAPI('ApprovalFlowServer');
    publicConfiguration["AdamServer"] = publicConfiguration.getBaseAPI('AdamServer');
    publicConfiguration["Thoth"] = publicConfiguration.getBaseAPI('Thoth');
    publicConfiguration["CognitoUserManager"] = publicConfiguration.getBaseAPI('CognitoUserManager');
    publicConfiguration["JobAuditTrailServer"] = publicConfiguration.getBaseAPI('JobAuditTrailServer');
    publicConfiguration["TalentAssessmentServer"] = publicConfiguration.getBaseAPI('TalentAssessmentServer');
    publicConfiguration["TalentPoolServer"] = publicConfiguration.getBaseAPI('TalentPoolServer');
    publicConfiguration["CoreHrUserPayrollProfileServer"] = publicConfiguration.getBaseAPI('CoreHrUserPayrollProfileServer');
    publicConfiguration["CoreHrUpdatesIntegrationServer"] = publicConfiguration.getBaseAPI('CoreHrUpdatesIntegrationServer');
    publicConfiguration["ABSServers"] = publicConfiguration.getBaseAPI('ABSServers');
    publicConfiguration["QuestionBankServers"] = publicConfiguration.getBaseAPI('QuestionBankServers');
    publicConfiguration["ParLaborServers"] = publicConfiguration.getBaseAPI('ParLaborServers');
    publicConfiguration["PermissionsServer"] = publicConfiguration.getBaseAPI('PermissionsServer');
    publicConfiguration["TeamLiveReports"] = publicConfiguration.getBaseAPI('TeamLiveReports');
    publicConfiguration["LMS_SERVERS"] = publicConfiguration.getBaseAPI('LMSServers');
    publicConfiguration["HARRI_UPSKILL_INTEGRATION"] = publicConfiguration.getBaseAPI('HarriUpskillIntegration');
    publicConfiguration["INTERNAL_ACADEMY"] = publicConfiguration.getBaseAPI('InternalAcademy');
    publicConfiguration["SocialReferralServers"] = publicConfiguration.getBaseAPI('SocialReferral');
    publicConfiguration["NotificationCenterServers"] = publicConfiguration.getBaseAPI('NotificationCenter');
    publicConfiguration["NotificationCenterServersV2"] = publicConfiguration.getBaseAPI('NotificationCenterV2');
    publicConfiguration["CorHrNotificationManagerServer"] = publicConfiguration.getBaseAPI('CorHrNotificationManagerServer');
    publicConfiguration["ScheduleBudgeting"] = publicConfiguration.getBaseAPI('ScheduleBudgeting');
    publicConfiguration["WendysLabor"] = publicConfiguration.getBaseAPI('WendysLabor');
    publicConfiguration["McDLabor"] = publicConfiguration.getBaseAPI('McDLabor');
    publicConfiguration["JibLabor"] = publicConfiguration.getBaseAPI('JibLabor');
    publicConfiguration["CarrolLabor"] = publicConfiguration.getBaseAPI('CarrolLabor');
    publicConfiguration["GastronomyLabor"] = publicConfiguration.getBaseAPI('GastronomyLabor');
    publicConfiguration["OperatingHours"] = publicConfiguration.getBaseAPI('OperatingHours');
    publicConfiguration["BackgroundCheckServer"] = publicConfiguration.getBaseAPI('BackgroundCheckServer');
    publicConfiguration["TimeKeepingAlertsServers"] = publicConfiguration.getBaseAPI('TimeKeepingAlertsServers');
    publicConfiguration["MinorSchedulingServers"] = publicConfiguration.getBaseAPI('MinorSchedulingServers');
    publicConfiguration["TeamLiveShiftOfferFinancials"] = publicConfiguration.getBaseAPI('TeamLiveShiftOfferFinancials');
    publicConfiguration["Announcements"] = publicConfiguration.getBaseAPI('Announcements');
    publicConfiguration["tsAnnouncements"] = publicConfiguration.getBaseAPI('tsAnnouncements');
    publicConfiguration["RecognitionServers"] = publicConfiguration.getBaseAPI('RecognitionServers');
    publicConfiguration["GatewayTeamLiveServer"] = publicConfiguration.getBaseAPI('GatewayTeamLiveServer');
    publicConfiguration["GatewayServer"] = publicConfiguration.getBaseAPI('GatewayServer');
    publicConfiguration["CommunityServer"] = publicConfiguration.getBaseAPI('CommunityServer');
    publicConfiguration["ZendeskServer"] = publicConfiguration.getBaseAPI('ZendeskServer');
    publicConfiguration["tsGatewayTeamLiveServer"] = publicConfiguration.getBaseAPI('tsGatewayTeamLiveServer');
    publicConfiguration["tsEmployeeBenefitsServer"] = publicConfiguration.getBaseAPI('tsEmployeeBenefitsServer');
    publicConfiguration["EmployeeBenefitsServer"] = publicConfiguration.getBaseAPI('EmployeeBenefitsServer');
    publicConfiguration["GatewayWeatherServer"] = publicConfiguration.getBaseAPI('GatewayWeatherServer');
    publicConfiguration["LPMStatsServer"] = publicConfiguration.getBaseAPI('LPMStatsServer');
    publicConfiguration["LPMIntegrationServer"] = publicConfiguration.getBaseAPI('LPMIntegrationServer');
    publicConfiguration["Logbook"] = publicConfiguration.getBaseAPI('Logbook');
    publicConfiguration["Carri"] = publicConfiguration.getBaseAPI('Carri');
    publicConfiguration["PreHire"] = publicConfiguration.getBaseAPI('PreHire');
    publicConfiguration["DataPassServers"] = publicConfiguration.getBaseAPI('DataPassServers');
    publicConfiguration["AccountManagement"] = publicConfiguration.getBaseAPI('AccountManagement');
    publicConfiguration["SymmetryManager"] = publicConfiguration.getBaseAPI('SymmetryManager');
    publicConfiguration["QuestioningServer"] = publicConfiguration.getBaseAPI('QuestioningServer');
    publicConfiguration["EmployeeClockStats"] = publicConfiguration.getBaseAPI('EmployeeClockStats');
    publicConfiguration["EmployeeNotes"] = publicConfiguration.getBaseAPI('EmployeeNotes');
    publicConfiguration["HumanResourceActionsServer"] = publicConfiguration.getBaseAPI('HumanResourceActionsServer');
    publicConfiguration["CorHrCustomFields"] = publicConfiguration.getBaseAPI('CorHrCustomFields');
    publicConfiguration["GiphyServer"] = publicConfiguration.getBaseAPI('GiphyServer');
    publicConfiguration["GiphyAPIKey"] = publicConfiguration.getBaseAPI('GiphyAPIKey');
    publicConfiguration["TsGiphyAPIKey"] = publicConfiguration.getBaseAPI('TsGiphyAPIKey');
    publicConfiguration["UserTrackingManagerServer"] = publicConfiguration.getBaseAPI('UserTrackingManagerServer');
    publicConfiguration["UserPreferencesManagerServer"] = publicConfiguration.getBaseAPI('UserPreferencesManagerServer');
    publicConfiguration["SettingsAudit"] = publicConfiguration.getBaseAPI('SettingsAudit');
    publicConfiguration["SpecialEvents"] = publicConfiguration.getBaseAPI('SpecialEvents');
    publicConfiguration["CognitoUserManager"] = publicConfiguration.getBaseAPI('CognitoUserManager');
    publicConfiguration["EmployeeAttestationServer"] = publicConfiguration.getBaseAPI('EmployeeAttestationServer');
    publicConfiguration["HarriEngageServer"] = publicConfiguration.getBaseAPI('HarriEngageServer');
    publicConfiguration["OnBoardingJourneyServer"] = publicConfiguration.getBaseAPI('OnBoardingJourneyServer');
    publicConfiguration["SubwayServer"] = publicConfiguration.getBaseAPI('SubwayServer');
    publicConfiguration["WorkRestriction"] = publicConfiguration.getBaseAPI('WorkRestriction');
    publicConfiguration["BrandGlossary"] = publicConfiguration.getBaseAPI('BrandGlossary');
    publicConfiguration["ExternalTipProvider"] = publicConfiguration.getBaseAPI('ExternalTipProvider');
    publicConfiguration["RewardAndRecognitionServer"] = publicConfiguration.getBaseAPI('RewardAndRecognitionServer');

    //Camera Tag Conf
    publicConfiguration["CameraTagAppKey"] = publicConfiguration.getCameraTagAppKey();
    publicConfiguration["CameraTagQuestionBankAppKey"] = publicConfiguration.getCameraTagQuestionBankAppKey();

    publicConfiguration["TranslationLookup"] = publicConfiguration.getBaseAPI('TranslationLookup');

    publicConfiguration["UsersSecondaryAuthServer"] = publicConfiguration.getBaseAPI('UsersSecondaryAuthServer');
    publicConfiguration["CoreHRPositionHierarchyServer"] = publicConfiguration.getBaseAPI('CoreHRPositionHierarchyServer');

    window.publicConfiguration = publicConfiguration;

    window.environmentsConfig = environmentsConfig;
}



//export public configuration to node.js app.
try {
    module.exports = publicConfiguration;
} catch (e) {
}
